<template>
  <nx-fullscreen-dialog
    :active="value"
    :title="title"
    @dismiss="$emit('input:dialog')"
  >
    <template slot="toolbar-items">
      <v-btn
        @click.native="accept"
        color="accent"
        dark flat
        v-html="$t('message.common.accept')"
      ></v-btn>
    </template>

    <nx-searcher
      :entity="currentEntity"
      :filters="filters"
      :sort="currentSort"
      :entityTabs="entityTabs"
      :preview="true"
      @setFilters="updateSearcherFilters"
      @updateSort="updateSort"
      @changeEntity="updateEntity"
    ></nx-searcher>
  </nx-fullscreen-dialog>
</template>

<script>
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import Searchable from '@/modules/searcher/mixins/searchable';
import NxSearcher from '@/modules/searcher/Searcher';

export default {
  name: 'nx-saved-searches-search-preview-dialog',
  mixins: [Searchable],
  components: {
    NxSearcher,
    NxFullscreenDialog,
  },
  props: {
    value: Boolean,
    title: {
      type: String,
    },
    entity: {
      type: String,
      required: true,
    },
    entityTabs: {
      type: [Boolean, Array],
      default: false,
    },
  },
  data() {
    return {
      currentEntity: null,
      filters: {},
      sort: null,
    };
  },
  computed: {
    defaultSort() {
      if (this.$store.getters.searcher[this.currentEntity]
        && this.$store.getters.searcher[this.currentEntity].sort) {
        return this.$store.getters.searcher[this.currentEntity].sort.default;
      }
      return null;
    },
    currentSort() {
      if (this.sort) {
        return this.sort;
      }
      return this.defaultSort;
    },
  },
  methods: {
    accept() {
      this.$emit('input', {
        entity: this.currentEntity,
        filters: this.filters,
        sort: this.currentSort,
      });
      this.$emit('input:dialog');
    },
    updateEntity(entity) {
      this.filters = {};
      this.sort = null;
      this.currentEntity = entity;
    },
    updateSearcherFilters(newFilters) {
      this.filters = newFilters;
    },
    updateSort(sort) {
      this.sort = sort;
    },
  },
  watch: {
    entity: {
      handler(value) {
        this.currentEntity = value;
      },
      immediate: true,
    },
  },
};
</script>
